export default __webpack_public_path__ + "static/media/shimla2.caae0847.jpg";